// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a4dd29b9","64":"571cfc0a","116":"119c6369","786":"1dd0aed3"}[chunkId] + ".chunk.js";
};